import { removeSecretRecord } from "../services/record.service";

type SnackbarFn = (
  message: string,
  options?: { variant?: "default" | "error" | "success" | "warning" | "info" },
) => void;

export async function handleSecretRecordAfterDownload(
  jobId: string | number | null | undefined,
  isSecret: boolean | null | undefined,
  options?: {
    onRemoved?: () => void | Promise<void>;
    enqueueSnackbar?: SnackbarFn;
  },
): Promise<boolean> {
  if (!isSecret || jobId == null || jobId === "") {
    return false;
  }

  try {
    const response = await removeSecretRecord(jobId);
    if (response?.status === 200) {
      options?.enqueueSnackbar?.("Gizli dosya başarıyla kaldırıldı.", { variant: "success" });
      await options?.onRemoved?.();
      return true;
    }
    options?.enqueueSnackbar?.("Gizli dosya kaldırılamadı.", { variant: "error" });
  } catch {
    options?.enqueueSnackbar?.("Gizli dosya kaldırılamadı.", { variant: "error" });
  }
  return false;
}
